import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ViewRole } from '../contract/view-role.contract';

@Injectable({ providedIn: 'root' })
export class RolesApiService {
  private url = environment.APP_USERROLE_SERVICE_BASE_URL + '/api/v1/roles';
  private byCustomer = 'by-customer';

  constructor(private http: HttpClient) {}

  public getRolesByUserCustomer(): Observable<ViewRole[]> {
    return this.http.get<ViewRole[]>(`${this.url}/${this.byCustomer}`);
  }
}
